<section class="asset-charge-detail glass-panel">
  <wn-admin-back-link link="/assets/charges" [label]="'ASSET_CHARGES.BACK' | translate"></wn-admin-back-link>
  @if (loadError(); as err) {
    <p class="asset-charge-detail__error" role="alert">{{ err }}</p>
  } @else if (loading()) {
    <p class="asset-charge-detail__status" role="status">{{ 'ASSET_CHARGES.LOADING' | translate }}</p>
  } @else if (charge(); as c) {
    <p class="eyebrow">{{ 'ASSET_CHARGES.TITLE' | translate }}</p>
    <h1>{{ c.userFullName || '-' }}</h1>
    <p class="lede">{{ 'ASSET_CHARGES.REASON.' + c.reason | translate }} · <wn-status-chip [label]="'ASSET_CHARGES.STATUS.' + c.status | translate" /></p>

    @if (canWaive() || canLink()) {
      <div class="asset-charge-detail__toolbar">
        @if (canLink()) {
          <button type="button" pButton [outlined]="true" icon="pi pi-link" class="asset-charge-detail__link-asset" [label]="'ASSET_CHARGES.LINK_ASSET' | translate" (click)="linkOpen.set(true)"></button>
        }
        @if (canWaive()) {
          <button type="button" pButton [outlined]="true" icon="pi pi-ban" class="asset-charge-detail__waive" [label]="'ASSET_CHARGES.WAIVE' | translate" (click)="waiveOpen.set(true)"></button>
        }
      </div>
    }

    <section class="wn-card">
      <dl class="asset-charge-detail__grid">
        @if (c.itemDescription) {
          <div class="asset-charge-detail__row"><dt>{{ 'ASSET_CHARGES.ITEM' | translate }}</dt><dd>{{ c.itemDescription }}</dd></div>
        }
        @if (c.assetId) {
          <div class="asset-charge-detail__row">
            <dt>{{ 'ASSET_CHARGES.ASSET' | translate }}</dt>
            <dd><a class="asset-charge-detail__asset" [routerLink]="['/assets', c.assetId]">{{ assetLabel() || c.assetId }}</a></dd>
          </div>
        }
        <div class="asset-charge-detail__row"><dt>{{ 'ASSET_CHARGES.TOTAL' | translate }}</dt><dd dir="ltr">{{ c.amount }}</dd></div>
        <div class="asset-charge-detail__row"><dt>{{ 'ASSET_CHARGES.DEDUCTED' | translate }}</dt><dd dir="ltr">{{ c.deducted }}</dd></div>
        <div class="asset-charge-detail__row"><dt>{{ 'ASSET_CHARGES.REMAINING' | translate }}</dt><dd dir="ltr">{{ c.remaining }}</dd></div>
        @if (c.status === 2) {
          <div class="asset-charge-detail__row"><dt>{{ 'ASSET_CHARGES.WAIVED_AMOUNT' | translate }}</dt><dd dir="ltr">{{ c.waivedAmount ?? 0 }}</dd></div>
          <div class="asset-charge-detail__row"><dt>{{ 'ASSET_CHARGES.WAIVE_REASON' | translate }}</dt><dd>{{ c.waiveReason || '-' }}</dd></div>
        }
        @if (c.note) {
          <div class="asset-charge-detail__row"><dt>{{ 'ASSET_CHARGES.NOTE' | translate }}</dt><dd>{{ c.note }}</dd></div>
        }
      </dl>
    </section>

    <section class="wn-card asset-charge-detail__section">
      <div class="wn-card__head">
        <strong>{{ 'ASSET_CHARGES.SCHEDULE' | translate }}</strong>
      </div>
      <div class="asset-charge-detail__table-wrap">
        <table class="asset-charge-detail__table">
          <thead>
            <tr>
              <th scope="col">{{ 'ASSET_CHARGES.NUMBER' | translate }}</th>
              <th scope="col">{{ 'ASSET_CHARGES.DUE' | translate }}</th>
              <th scope="col">{{ 'ASSET_CHARGES.AMOUNT' | translate }}</th>
              <th scope="col">{{ 'ASSET_CHARGES.STATUS_LABEL' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of c.schedule; track row.number) {
              <tr class="asset-charge-detail__installment">
                <td dir="ltr">{{ row.number }}</td>
                <td>{{ row.dueDate | date: 'mediumDate':'UTC' }}</td>
                <td dir="ltr">{{ row.amount }}</td>
                <td>
                  <span class="asset-charge-detail__badge" [class.is-deducted]="row.deducted">
                    {{ (row.deducted ? 'ASSET_CHARGES.DEDUCTED_BADGE' : 'ASSET_CHARGES.PENDING_BADGE') | translate }}
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>

    @if (waiveOpen()) {
      <app-waive-charge-dialog [chargeId]="c.id" (waived)="onWaived()" (closed)="waiveOpen.set(false)" />
    }
    @if (linkOpen()) {
      <app-link-asset-dialog [chargeId]="c.id" (linked)="onLinked()" (closed)="linkOpen.set(false)" />
    }
  }
</section>
